import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import TeletelMetaIndex from './Index.vue';

// The Meta page (owner order 2026-09-25): status of every WhatsApp Cloud
// number at Meta, the notices log and the templates. Administrators only.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/teletel-meta'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => ({ name: 'teletel_meta', params: to.params }),
        },
        {
          path: 'list',
          name: 'teletel_meta',
          meta: {
            permissions: ['administrator'],
          },
          component: TeletelMetaIndex,
        },
      ],
    },
  ],
};
